module.exports = __webpack_public_path__ + "img/2d8f910.jpg";